var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-10"},[(_vm.isAdmin || _vm.isDataEntry || _vm.isDataEntryAndDispatcher)?_c('Header'):_vm._e(),_c('Table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }